<nav class="navbar navbar-dark sticky-top bg-dark flex-column p-0">
  <div class="col-12 bg-white">
    <div class="row">
      <div class="badminton-manual d-none d-sm-block col-sm-2">
        <a href="javascript:void(0)" class="font-weight-bold"><i class="fa fa-file-pdf-o" ></i> Manual</a>
      </div>
      <div class="col-7 col-sm-7 badminton-information text-right">
        <span class="badminton-usertitle">Usuario: </span>
        <span class="badminton-usersubtitle">{{usuario}}</span>
        <span class="badminton-usertitle pl-5 d-none d-sm-inline">Perfil: </span>
        <span class="badminton-usersubtitle d-none d-sm-inline">{{perfil}}</span>
      </div>
      <div class="col-5 col-sm-3 text-right badminton-logout">
        <span (click)="logout()">Cerrar sesión</span>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="row">
      <div class="badminton-sistema col-sm-12 col-md-8 col-lg-11 mr-0">
        <p>Sistema de registro del aula virtual de badminton</p>
            <p>FEDERACIÓN DEPORTIVA PERUANA DE BÁDMINTON</p>
      </div>
      <div class="badminton-logo d-none d-md-block col-md-4 col-lg-1">
         
      </div>
    </div>
  </div>
</nav>

<div class="container-fluid">
  <div class="row">
    
    <app-menu class="col-xl-2 col-md-3 bg-light p-0 pt-2"></app-menu>

    <main role="main" class="col-xl-10 col-md-9 ml-sm-auto pt-3 px-4">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
